import { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const AutomatedAuditLoader: FC = (): JSX.Element => {
  return <span className={classNames(styles['dots-circle-spinner'], styles['loading'])}></span>;
};

export default AutomatedAuditLoader;
